<div class="change-chart d-flex align-items-center justify-content-end mb-3" *ngIf="cShowChartOptions">
  <!-- <div>Choose Chart Type</div> -->
  <div *ngFor="let chartType of cChartTypes" class="ml-4 h4 mb-0 mt-0">
    <i [ngClass]="['fa-chart-' + chartType, 'fas']" (click)="cType = chartType"></i>
  </div>
  <!-- <i class="fas fa-chart-bar ml-4 h4 mb-0 mt-0" (click)="cType = 'bar'"></i>
  <i class="fas fa-chart-line ml-4 h4 mb-0 mt-0" (click)="cType = 'line'"></i>
  <i class="fas fa-chart-pie ml-4 h4 mb-0 mt-0" (click)="cType = 'pie'"></i> -->
</div>

<div
  *ngIf="cData[0].data.length > 0"
  [style.height.vh]="overrideHeight == null ? 30 : overrideHeight"
>
  <div
    class="chart-container"
    style="position: relative; height: 100%; width: 100%"
  >
    <canvas
      baseChart
      [type]="cType"
      [datasets]="cData"
      [labels]="cLabels"
      [options]="chartOptions"
    >
    </canvas>
  </div>
</div>
